import { connect } from 'react-redux';
import AnimateRoutes from 'components/AnimateRoutes';
import { completeGoBack } from 'routes/reducer';
import { goingBackSelector } from 'routes/selectors';

const mapStateToProps = (state, ownProps) => ({
  goingBack: goingBackSelector(state),
  location: ownProps.location
});

function mapDispatchToProps(dispatch) {
  return {
    completeGoBack: () => dispatch(completeGoBack())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnimateRoutes);
